export const getLimitPages = (total, limit) => {
  if (!limit || total <= limit) return 1;
  return Math.ceil(total / limit);
};

export const setLocalRoute = (route) => {
  let dataLogin = JSON.parse(localStorage.getItem('dataLogin'));
  if (dataLogin) {
    localStorage.setItem('dataLogin', JSON.stringify({ ...dataLogin, route }));
  }
};

export const getURLParams = () => {
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const goto = urlParams.get('goto');
  return goto;
};

export const formattedDestinations = (destinations) => {
  let arr = [];
  destinations.forEach((destination) => {
    if (destination) destination.lat = destination?.latLng?.lat;
    destination.lng = destination?.latLng?.lng;
    arr.push(destination);
  });
  return arr;
};
